import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { graphService, MapCoordinatesResponse } from "../../services/graphService";
import { queryKeys } from "./keys";

interface MapFilterParams {
  search?: string;
  facility_types?: string[];
  home_country?: string[];
  naics?: string[];
  input_hs_codes?: string[];
  output_hs_codes?: string[];
  facility_owners?: string[];
  facility_owner_max_tiers?: number;
  facility_statuses?: string[];
  suppliers?: string[];
  customers?: string[];
  labels?: string[];
  updated_date_start?: string;
  updated_date_end?: string;
}

/**
 * TanStack Query hook for fetching map coordinates.
 *
 * Uses `keepPreviousData` so the map stays populated while new results load.
 * A 5-minute staleTime avoids re-fetching on every filter panel interaction.
 */
export function useMapCoordinates(
  filters: MapFilterParams,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: queryKeys.graph.mapCoordinates(filters as Record<string, unknown>),
    queryFn: () => graphService.getMapCoordinates(40000, filters),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
